export const companies = [
    {
        url: 'https://www.mercadoshops.com.ar/landings/shops',
        title: 'Mercado Shops',
        img: '/images/companies/mercado.webp',
        carrousel: true,
    },
    {
        url: 'https://www.trinitycollege.com/',
        title: 'Trinity College London',
        img: '/images/companies/trinity.webp',
        carrousel: true,
    },
    {
        url: 'https://recla.org/',
        title: 'Red de Educación Continua de Latinoamérica y Europa',
        img: '/images/companies/recla.webp',
        carrousel: true,
        linkOnCarrousel: true,
    },
    { url: 'https://realcup.org/', title: 'RealCup', img: '/images/companies/realcup.webp', carrousel: true },
    { url: 'https://www.inqaahe.org/', title: 'Inqaahe', img: '/images/companies/inqaahe.webp', carrousel: true },
    {
        url: 'https://www.anahuac.mx/',
        title: 'Red de Universidades Anáhuac',
        img: '/images/companies/anahuac.webp',
        carrousel: true,
    },
    {
        url: 'http://www.ucnl.edu.mx/',
        title: 'Universidad Ciudadana de Nuevo León',
        img: '/images/companies/leon.webp',
        carrousel: true,
    },
    {
        url: 'https://universidadinsurgentes.edu.mx/',
        title: 'Universidad Insurgentes',
        img: '/images/companies/insurgentes.webp',
        carrousel: true,
    },
    {
        url: 'https://www.senai.portaldaindustria.com.br/',
        title: 'Serviço Nacional de Aprendizagem Industrial',
        img: '/images/companies/industrial.webp',
        carrousel: true,
    },
    {
        url: 'https://www.utdt.edu/',
        title: 'Universidad Torcuato Di Tella',
        img: '/images/companies/ditella.webp',
        carrousel: true,
    },
    {
        url: 'https://udesa.edu.ar/',
        title: 'Universidad de San Andrés',
        img: '/images/companies/sanandres.webp',
        carrousel: true,
    },
    {
        url: 'https://ucema.edu.ar/',
        title: 'Universidad del Cema',
        img: '/images/companies/cema.webp',
        carrousel: true,
    },
    { url: 'https://essarp.org.ar/es/', title: 'Essarp', img: '/images/companies/essarp.webp', carrousel: true },
    {
        url: 'https://fondationforge.org/',
        title: 'Forge Fundación',
        img: '/images/companies/forge.webp',
        carrousel: true,
    },
    { url: 'https://www.utnlabs.com/es/', title: 'UTN. Labs', img: '/images/companies/utn.webp', carrousel: true },
    { url: 'https://unsam.edu.ar/', title: 'Unsam', img: '/images/companies/unsam.webp', carrousel: true },
    {
        url: 'https://reditinere.com/',
        title: 'Itenere Red Educativa',
        img: '/images/companies/ire.webp',
        carrousel: true,
    },
    {
        url: 'https://www.coderhouse.com/',
        title: 'Coder House',
        img: '/images/companies/coderhouse.webp',
        carrousel: true,
    },
    { url: 'https://www.soyhenry.com/', title: 'Soy Henry', img: '/images/companies/soyhenry.webp', carrousel: true },
    {
        url: 'https://icponline.org/',
        title: 'International Confederation of Principals',
        img: '/images/companies/principals.webp',
        carrousel: true,
    },
    {
        url: 'https://portal.usac.edu.gt/',
        title: 'Universidad de San Carlos de Guatemala',
        img: '/images/companies/guatemala.webp',
        carrousel: true,
    },
    {
        url: 'https://www.utpl.edu.ec/',
        title: 'La Universidad Católica de Loja',
        img: '/images/companies/loja.webp',
        carrousel: true,
    },
    { url: 'https://www.griky.co/', title: 'Griky', img: '/images/companies/griky.webp', carrousel: true },
    { url: 'https://edutechca.com/', title: 'Edutech', img: '/images/companies/edutech.webp', carrousel: true },
    { url: 'https://bedu.org/', title: 'Bedu', img: '/images/companies/bedu.webp', carrousel: true },
    {
        url: 'https://www.cesa.edu.co/',
        title: 'Colegio de Estudios Superiores de Administración',
        img: '/images/companies/cesa.webp',
        carrousel: true,
    },
    { url: 'https://www.lewagon.com/', title: 'le wagon', img: '/images/companies/wagon.webp', carrousel: true },
    { url: 'https://es.totvs.com/', title: 'TOTVS', img: '/images/companies/totvs.webp', carrousel: true },
    {
        url: 'https://www.ipl.pt/',
        title: 'Politécnico de Lisboa',
        img: '/images/companies/lisboa.webp',
        carrousel: true,
    },
    { url: 'https://www.ufv.es/', title: 'Universidad Francisco de Victoria', img: '/images/companies/ufv.webp' },
    {
        url: 'https://www.lasallecentrouniversitario.es/',
        title: 'La Salle Centro Universitario',
        img: '/images/companies/lasalle.webp',
        carrousel: true,
    },
    {
        url: 'https://www.unisabana.edu.co/',
        title: 'Universidad de La Sabana',
        img: '/images/companies/sabana.webp',
        carrousel: true,
    },
    {
        url: 'https://www.uai.cl/',
        title: 'Universidad Adolfo Ibáñez',
        img: '/images/companies/adolfo.webp',
        carrousel: true,
    },
    {
        url: 'https://ubolivariana.cl/',
        title: 'Universidad Bolivariana',
        img: '/images/companies/bolivariana.webp',
        carrousel: true,
    },
    {
        url: 'https://www.ubo.cl/',
        title: 'Universidad Bernardo O’Higgins',
        img: '/images/companies/ohiggins.webp',
        carrousel: true,
    },
    {
        url: 'https://uai.edu.ar/',
        title: 'Universidad Abierta Interamericana',
        img: '/images/companies/uai.webp',
        carrousel: true,
    },
    {
        url: 'https://21.edu.ar/',
        title: 'Universidad Siglo 21',
        img: '/images/companies/siglo21.webp',
        carrousel: true,
    },
    {
        url: 'https://www.uflouniversidad.edu.ar/',
        title: 'UFLO Universidad',
        img: '/images/companies/uflo.webp',
        carrousel: true,
    },
    {
        url: 'https://www.ubp.edu.ar/',
        title: 'Universidad Blas Pascal',
        img: '/images/companies/blaspascal.webp',
        carrousel: true,
    },
    { url: 'https://www.endeavor.org.ar/', title: 'endeavor', img: '/images/companies/endeavor.webp', carrousel: true },
    { url: 'https://junior.org.ar/', title: 'Junior Achievement', img: '/images/companies/junior.webp' },
    {
        url: 'https://www.amba-bga.com/bga',
        title: 'Business Graduates Association',
        img: '/images/companies/bga.webp',
        carrousel: true,
    },
    {
        url: 'https://www.ucu.edu.uy/',
        title: 'Universidad Católica del Uruguay',
        img: '/images/companies/ucu.webp',
        carrousel: true,
    },
    {
        url: 'https://fundacionblockchain.com/',
        title: 'Fundación Blockchain Argentina',
        img: '/images/companies/blockchain.webp',
        carrousel: true,
    },
    {
        url: 'https://www.wcu.academy/es/',
        title: 'Federación Internacional de Universidades Católicas',
        img: '/images/companies/fiuc.webp',
        carrousel: true,
    },
    { url: 'https://www.edutic.org/', title: 'eDutic', img: '/images/companies/edutic.webp', carrousel: true },
    { url: 'https://www.himss.org/', title: 'Himss', img: '/images/companies/himss.webp', carrousel: true },
    { url: 'https://buenosaires.gob.ar/inicio/', title: 'BA', img: '/images/companies/ba.webp', carrousel: true },
    { url: 'https://cace.org.ar/', title: 'Cace', img: '/images/companies/cace.webp', carrousel: true },
    {
        url: 'https://camarafintech.org/',
        title: 'Cámara Argentina Fintech',
        img: '/images/companies/caf.webp',
        carrousel: true,
    },
    { url: 'https://www.talisis.com/', title: 'Talisis', img: '/images/companies/talisis.webp', carrousel: true },
    {
        url: 'https://ucom.edu.py/',
        title: 'Universidad Comunera',
        img: '/images/companies/comunera.webp',
        carrousel: true,
    },
    {
        url: 'https://scalalearning.com/',
        title: 'Scala Learning',
        img: '/images/companies/scala.webp',
        carrousel: true,
    },
    { url: 'https://www.eidosglobal.org/', title: 'Eidos', img: '/images/companies/eidos.webp', carrousel: true },
    {
        url: 'https://northvalley.app/',
        title: 'North Valley',
        img: '/images/companies/northvalley.webp',
        carrousel: true,
    },
    {
        url: 'https://www.bestbuddies.org.co/',
        title: 'Escuela Best Buddies Colombia',
        img: '/images/companies/bestbuddies.webp',
        carrousel: true,
    },
    { url: 'https://www.ufro.cl/', title: 'Universidad de la Frontera', img: '/images/companies/frontera.webp' },
    {
        url: 'https://www.ucentral.edu.co/',
        title: 'Universidad Central',
        img: '/images/companies/universidadcentral.webp',
    },
    { url: 'https://bds.edu.ar/', title: 'Belgrano Day School', img: '/images/companies/belgranodayschool.webp' },
    {
        url: 'https://rededucacioncontinua.cl/',
        title: 'Red Universitaria de Educación Continua',
        img: '/images/companies/rudc.webp',
    },
    { url: 'https://www.plataforma5.la/', title: 'Plataforma 5', img: '/images/companies/plataforma5.webp' },
    {
        url: 'https://unae.edu.py/tv/',
        title: 'Universidad Autónoma de Encarnación',
        img: '/images/companies/unae.webp',
    },
    {
        url: 'https://ucontinental.edu.pe/',
        title: 'Universidad Continental',
        img: '/images/companies/continental.webp',
    },
    {
        url: 'https://www.ispc.edu.ar/',
        title: 'Instituto Superior Politécnico Córdoba',
        img: '/images/companies/ispc.webp',
    },
    { url: 'https://www.umayor.cl/santiago', title: 'Universidad Mayor', img: '/images/companies/mayor.webp' },
    {
        url: 'https://www.realmadrid.com/es-ES/fundacion',
        title: 'Fundación Real Madrid',
        img: '/images/companies/realmadrid.webp',
    },
    { url: 'https://universidadean.edu.co/', title: 'UEAN', img: '/images/companies/uniean.webp', carrousel: true },
    {
        url: 'https://graduados.eco.unc.edu.ar/es/',
        title: 'Escuela de Graduados FCE - UNC',
        img: '/images/companies/fceunc.webp',
    },
    { url: 'https://ensenaporparaguay.org/', title: 'Enseña por Paraguay', img: '/images/companies/paraguay.webp' },
    { url: 'https://www.pucv.cl/', title: 'Universidad Católica de Valparaíso', img: '/images/companies/ucv.webp' },
    { url: 'https://innovacion.itba.edu.ar/', title: 'ITBA Escuela de Innovación', img: '/images/companies/itba.webp' },
    { url: 'https://www.usach.cl/', title: 'Universidad Santiago de Chile', img: '/images/companies/usach.webp' },
    { url: 'https://usantapaula.com/', title: 'Universidad Santa Paula', img: '/images/companies/santapaula.webp' },
    { url: 'https://www.unc.edu.ar/', title: 'UNC', img: '/images/companies/unc.webp' },
    { url: 'https://redvcm.org/', title: 'Red de Vinculación con el Medio', img: '/images/companies/rvm.webp' },
    {
        url: 'https://ipss.cl/',
        title: 'Instituto Profesional San Sebastian',
        img: '/images/companies/sansebastian.webp',
    },
    { url: 'https://www.cetys.mx/', title: 'Cetys Universidad', img: '/images/companies/cetys.webp' },
    {
        url: 'https://cenia.cl',
        title: 'Centro Nacional de Inteligencia Artificial',
        img: '/images/companies/cenia.webp',
    },
    {
        url: 'https://centrodeeducacioncontinua.uabc.mx/',
        title: 'Centro de Educación Continua UABC',
        img: '/images/companies/uabc.webp',
        carrousel: true,
    },
    {
        url: 'https://filadd.com.co/',
        title: 'Filadd',
        img: '/images/companies/filadd.webp',
        carrousel: true,
        linkOnCarrousel: true,
    },
    {
        url: 'https://www.latech.edu/',
        title: 'Louisiana Tech University',
        img: '/images/companies/louisiana.webp',
        carrousel: true,
    },
    {
        url: 'https://www.uhs.org.uk/',
        title: 'Uxbridge High School',
        img: '/images/companies/uxbridge.webp',
        carrousel: true,
    },
    {
        url: 'https://sceu.frba.utn.edu.ar/e-learning/',
        title: 'UTN BA',
        img: '/images/companies/utnba.webp',
        carrousel: true,
    },
    {
        url: 'https://usi.edu.ar/',
        title: 'Universidad de San Isidro',
        img: '/images/companies/usi.webp',
        carrousel: true,
    },
    {
        url: 'https://www.uag.mx/',
        title: 'Universidad Autónoma de Guadalajara',
        img: '/images/companies/uag.webp',
        carrousel: true,
    },
    {
        url: 'https://www.uat.edu.mx/',
        title: 'Universidad Autónoma de Tamaulipas',
        img: '/images/companies/uat.webp',
        carrousel: true,
    },
    {
        url: 'https://www.ucasal.edu.ar/',
        title: 'Universidad Católica de Salta',
        img: '/images/companies/ucasal.webp',
        carrousel: true,
    },
    {
        url: 'https://www.asugsvsummit.com/sponsor-partners/proof-of-knowledge-pok',
        title: 'ASU',
        img: '/images/companies/asu.webp',
        carrousel: true,
    },
    {
        url: 'https://elevateedgepartners.com/',
        title: 'Elevate Edge',
        img: '/images/companies/elevate.webp',
        carrousel: true,
    },
    { url: 'https://ibero.mx/', title: 'Ibero', img: '/images/companies/ibero.webp', carrousel: true },
    { url: 'https://alata.education/', title: 'Alata', img: '/images/companies/alata.webp', carrousel: true },
    { url: 'https://insp.mx/', title: 'INSP', img: '/images/companies/insp.webp', carrousel: true },
    {
        url: 'https://www.saddleriverday.org/',
        title: 'Saddle River Day School',
        img: '/images/companies/saddle.webp',
        carrousel: true,
    },
    {
        url: 'https://www.thinklbx.com/',
        title: 'Lightbox Consulting',
        img: '/images/companies/lightbox.webp',
        carrousel: true,
    },
    {
        url: 'https://www.aifyc.eu/certificacion/',
        title: 'aifyc',
        img: '/images/companies/aifyc.webp',
        carrousel: true,
    },
    {
        url: 'https://www.teachthefuture.org/',
        title: 'Teach The Future',
        img: '/images/companies/teachthefuture.webp',
        carrousel: true,
    },
    { url: 'https://www.uean.edu.ar/', title: 'Universidad EAN', img: '/images/companies/uean.webp' },
    {
        url: 'https://www.urp.edu.pe/',
        title: 'Universidad Ricardo Palma',
        img: '/images/companies/palma.webp',
        carrousel: true,
    },
    { url: 'https://upt.com.ar/', title: 'UPT', img: '/images/companies/upt.webp' },
    { url: 'https://www.upc.edu.pe/', title: 'UPC', img: '/images/companies/upc.webp', carrousel: true },
    {
        url: 'https://www.ufasta.edu.ar/',
        title: 'Universidad Fasta',
        img: '/images/companies/fasta.webp',
        carrousel: true,
    },
    { url: 'https://ecotec.edu.ec/', title: 'Universidad Ecotec', img: '/images/companies/ecotec.webp' },
    {
        url: 'https://www.uandes.cl/',
        title: 'Universidad de los Andes',
        img: '/images/companies/andes.webp',
        carrousel: true,
    },
    { url: 'https://www.udemm.edu.ar/', title: 'UdeMM', img: '/images/companies/udemm.webp', carrousel: true },
    {
        url: 'https://uady.mx/',
        title: 'Universidad Autónoma de Yucatán',
        img: '/images/companies/uady.webp',
        carrousel: true,
    },
    {
        url: 'https://www.isdi.education/es',
        title: 'ISDI Education',
        img: '/images/companies/isdi.webp',
        carrousel: true,
    },
    {
        url: 'https://upt.com.ar',
        title: 'Universidad Popular de los y las Trabajabadoras de Mar del Plata y Zona Atlántica',
        img: '/images/companies/upt.webp',
        carrousel: true,
    },
    { url: 'https://ceipa.edu.co/', title: 'Fundación Universitaria CEIPA', img: '/images/companies/ceipa.webp' },
    { url: 'https://epiclab.itam.mx/', title: 'EPIC Lab ITAM', img: '/images/companies/epiclab.webp' },
    {
        url: 'https://www.upsa.edu.bo/',
        title: 'Universidad Privada de Santa Cruz de la Sierra',
        img: '/images/companies/upsa.webp',
    },
    {
        url: 'https://riaces.org/',
        title: 'Red Iberoamericana para el Aseguramiento de la Calidad en la Educación Superior',
        img: '/images/companies/riaces.webp',
    },
    { url: 'https://ubi.edu/', title: 'UBI Business School', img: '/images/companies/ubi.webp' },
    { url: 'https://www.emeb.es/', title: 'EMEB', img: '/images/companies/emeb.webp' },
    { url: 'https://www.ucf.cat/es', title: 'UCF', img: '/images/companies/ucf.webp' },
    { url: 'https://felgtbi.org/', title: 'FELGTBI+', img: '/images/companies/felgtbi.webp' },
    { url: 'https://www.femfuturum.es/', title: 'Fem Futurum', img: '/images/companies/femfuturum.webp' },
    { url: 'https://www.um.edu.uy/', title: 'Universidad de Montevideo', img: '/images/companies/um.webp' },
    {
        url: 'https://sightex.ae/',
        title: 'Sightex Strategy Institute for Growth and Hands on Training FZ LLC',
        img: '/images/companies/sightex.webp',
    },
    { url: 'https://www.senpx.com/', title: 'SENP-X', img: '/images/companies/senpx.webp' },
    { url: 'https://www.dx-learning.com/', title: 'DX Learning', img: '/images/companies/dxlearning.webp' },
    {
        url: 'https://www.southfayette.org/',
        title: 'South Fayette Township School District',
        img: '/images/companies/southfayette.webp',
    },
    {
        url: 'https://stemschools.org/',
        title: 'National Consortium of STEM Schools',
        img: '/images/companies/stemschools.webp',
    },
    { url: 'https://utec.edu.uy/en/', title: 'UTEC', img: '/images/companies/utec.webp' },
    {
        url: 'https://unica.edu.co/',
        title: 'ÚNICA - Institución Universitaria Colombo Americana',
        img: '/images/companies/unica.webp',
    },
    {
        url: 'https://albus.lat/',
        title: 'Academy of Latin American Business and Sustainability Studies',
        img: '/images/companies/albus.webp',
    },
    {
        url: 'https://postgrados.ucu.edu.uy/',
        title: 'UCU Escuela de Postgrados',
        img: '/images/companies/postgrados.webp',
    },
    { url: 'https://www.elabfellows.org/', title: 'eLab', img: '/images/companies/elabfellows.webp' },
    { url: 'https://uruguay.endeavor.org/', title: 'Endeavor Uruguay', img: '/images/companies/endeavoruruguay.webp' },
    { url: 'https://apaie.net/', title: 'APAIE', img: '/images/companies/apaie.webp' },
    { url: 'https://salesiana.edu.co/', title: 'SALESIANA', img: '/images/companies/salesiana.webp' },
    { url: 'https://www.aims.edu/', title: 'Aims Community College', img: '/images/companies/aims.webp' },
    {
        url: 'https://www.ucsg.edu.ec/',
        title: 'Universidad Católica de Santiago de Guayaquil',
        img: '/images/companies/ucsg.webp',
    },
    {
        url: 'https://www.uide.edu.ec/facultad-business-school/',
        title: 'Business School de la Universidad Internacional del Ecuador',
        img: '/images/companies/uide.webp',
    },
    { url: 'https://www.espol.edu.ec/es', title: 'Espol', img: '/images/companies/espol.webp' },
    { url: 'https://www.senati.edu.pe/', title: 'SENATI', img: '/images/companies/senati.webp' },
    { url: 'https://www.uss.edu.pe/', title: 'Universidad Señor de Sipan', img: '/images/companies/uss.webp' },
    { url: 'https://www.udalba.cl/', title: 'Universidad del Alba', img: '/images/companies/udalba.webp' },
    { url: 'https://uees.edu.ec/', title: 'UEES', img: '/images/companies/uees.webp' },
    {
        url: 'https://www.argentina.gob.ar/salud',
        title: 'Ministerio de Salud de la Nación',
        img: '/images/companies/msal.webp',
    },
    {
        url: 'https://educacioncontinua.ufro.cl/',
        title: 'Educación Continua - Universidad de La Frontera',
        img: '/images/companies/educacioncontinua.webp',
    },
    { url: 'https://cl.techo.org/', title: 'Techo Chile', img: '/images/companies/techo.webp' },
    { url: 'https://www.barcelo.edu.ar/', title: 'Fundación H. A. Barceló', img: '/images/companies/barcelo.webp' },
    { url: 'https://www.iae.edu.ar/', title: 'IAE Business School', img: '/images/companies/iae.webp' },
    { url: 'https://udeccapacita.cl/', title: 'UdeC Capacita', img: '/images/companies/udeccapacita.webp' },
    {
        url: 'https://www.aneaes.gov.py/inicio/',
        title: 'ANEAES - Agencia Nacional de Evaluación y Acreditación de la Educación Superior',
        img: '/images/companies/aneaes.webp',
    },
    { url: 'https://www.udb.edu.sv/', title: 'Universidad Don Bosco', img: '/images/companies/udb.webp' },
    { url: 'https://genially.com/es/', title: 'Genially', img: '/images/companies/genially.webp' },
    { url: 'https://esiap.gob.sv/', title: 'ESIAP', img: '/images/companies/esiap.webp' },
    { url: 'https://learnia.io/', title: 'Learnia', img: '/images/companies/learnia.webp' },
    { url: 'https://cugdl.udg.mx/', title: 'Centro Universitario de Guadalajara', img: '/images/companies/cugdl.webp' },
    { url: 'https://www.sovra.io/', title: 'Sovra', img: '/images/companies/sovra.webp' },
    { url: 'https://colombiaedtech.org/', title: 'Colombia Edtech', img: '/images/companies/colombiaedtech.webp' },
    { url: 'https://www.eduialogic.com/', title: 'EduIAlogic', img: '/images/companies/eduialogic.webp' },
    { url: 'https://www.evalmax.com/', title: 'EvalMAX', img: '/images/companies/evalmax.webp' },
    { url: 'https://token.trampoline.network/', title: 'Trampoline', img: '/images/companies/trampoline.webp' },
    { url: 'https://uplanner.com/', title: 'uPlanner', img: '/images/companies/uplanner.webp' },
    { url: 'https://lnet.global/', title: 'LNET', img: '/images/companies/lnet.webp' },
    { url: 'https://myiee.org/', title: 'IEE', img: '/images/companies/myiee.webp' },
    { url: 'https://merahki.ai/', title: 'Merahki', img: '/images/companies/merahki.webp' },
    { url: 'https://gruponods.com/', title: 'Grupo NODS', img: '/images/companies/gruponods.webp' },
];
